import {wrapGptDefineSlotsScript} from '@/utils/gptAds';

let injected = false;

/**
 * Inject raw HTML/JS from channel google_ads settings into document <head>.
 * Script nodes are recreated so they execute (cloned script tags from innerHTML do not).
 * GPT slot-definition snippets are wrapped as window.defineGptSlots so Vue can
 * re-run them after client-side navigation.
 * No-ops when html is null/empty or when already injected once.
 * @param {string|null|undefined} html
 */
export function injectCustomHeadTags(html) {
  if (injected || !html || typeof html !== 'string') return;

  const container = document.createElement('div');
  container.innerHTML = html.trim();
  if (!container.childNodes.length) return;

  injected = true;

  // Append at the end of <head>, right before </head>
  document.head.appendChild(document.createComment(' Custom Head Tags '));

  Array.from(container.childNodes).forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE && !node.textContent?.trim()) return;

    if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'SCRIPT') {
      const script = document.createElement('script');
      Array.from(node.attributes).forEach((attr) => {
        script.setAttribute(attr.name, attr.value);
      });
      if (node.textContent) {
        script.text = wrapGptDefineSlotsScript(node.textContent);
      }
      document.head.appendChild(script);
      return;
    }

    document.head.appendChild(node.cloneNode(true));
  });
}

export function resetCustomHeadTagsInjection() {
  injected = false;
}
